<ng-container *ngIf="result.isValid() && !result.hasSuggestions()">
<button mat-stroked-button>
   <mat-icon>thumb_up</mat-icon> <ng-container i18n>Workflow is valid</ng-container>
</button>
</ng-container>

<ng-container *ngIf="result.hasSuggestions() && !result.hasErrors()">
<button mat-stroked-button>
   <mat-icon>help_outline</mat-icon> <ng-container i18n>View suggestions</ng-container>
</button>
</ng-container>

<ng-container *ngIf="result.hasErrors()">
<button mat-stroked-button>
       <mat-icon>error</mat-icon> <ng-container i18n>View errors</ng-container>
</button>
</ng-container>